export default __webpack_public_path__ + "static/mail-a0011fe8bdfee3202f18200853445980.svg";